var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from 'react';
import { difference, intersection, keys } from 'lodash';
import useForm from 'react-hook-form';
import { defineMessages, useIntl } from 'react-intl';
import { number, object, string } from 'yup';
import { EmailSignUpFormStyle } from './email-signup-form.style';
import { SignUpTerms } from './signup-terms';
import { useAppleLogin } from './use-apple-login';
import { useFacebookLogin } from './use-facebook-login';
import { useGoogleLogin } from './use-google-login';
import { AppleButton, Button, FaceBookButton, GoogleButton } from '../buttons';
import { InputError, InputField } from '../Input';
import { AuthModalContext } from '../providers';
import { useCookies, useEventListener, useRecaptcha, useRequest } from '../../shared/hooks';
export var EmailSignUpForm = function (_a) {
    var _b = _a.isModal, isModal = _b === void 0 ? true : _b, redirectTo = _a.redirectTo, _c = _a.showSocialLogins, showSocialLogins = _c === void 0 ? true : _c, team = _a.team;
    var _d = useRecaptcha(), isRecaptchaLoading = _d.isRecaptchaLoading, recaptchaResponse = _d.recaptchaResponse, recaptchaRef = _d.recaptchaRef, executeRecaptcha = _d.executeRecaptcha, recaptchaError = _d.recaptchaError;
    var execute = useRequest({ isAjaxRequest: true }).execute;
    var appleSignUp = useAppleLogin().appleSignUp;
    var _e = useFacebookLogin(redirectTo), facebookSignup = _e.facebookSignup, isFacebookLoading = _e.isFacebookLoading;
    var _f = useGoogleLogin(redirectTo), googleSignup = _f.googleSignup, isGoogleLoading = _f.isGoogleLoading;
    var authContext = useContext(AuthModalContext);
    var _g = __read(useState(''), 2), generalError = _g[0], setGeneralError = _g[1];
    var _h = __read(useState(false), 2), isSubmitting = _h[0], setIsSubmitting = _h[1];
    var cookies = useCookies().cookies;
    var csrfToken = cookies && cookies.YII_CSRF_TOKEN ? cookies.YII_CSRF_TOKEN : '';
    var intl = useIntl();
    var emailSignUpMessages = defineMessages({
        firstNameMaxLengthMessage: {
            id: 'authentication.email-sign-up-form.first-name.max-length',
            description: 'Maximum number of characters allowed message for first name field',
            defaultMessage: 'Name fields must be fewer than 50 characters',
        },
        firstNameRequiredMessage: {
            id: 'authentication.email-sign-up-form.first-name.required-field',
            description: 'Required value message - Used on first name field',
            defaultMessage: 'First Name is required',
        },
        lastNameMaxLengthMessage: {
            id: 'authentication.email-sign-up-form.last-name.max-length',
            description: 'Maximum number of characters allowed message - Used on first name field',
            defaultMessage: 'Name fields must be fewer than 50 characters',
        },
        lastNameRequiredMessage: {
            id: 'authentication.email-sign-up-form.last-name.required-field',
            description: 'Required value message - Used on last name field',
            defaultMessage: 'Last Name is required',
        },
        companyRequiredMessage: {
            id: 'authentication.email-sign-up-form.company.required',
            description: 'Required value message - Used on company field',
            defaultMessage: 'Company is required',
        },
        emailMinLengthMessage: {
            id: 'authentication.email-sign-up-form.email.min-length',
            description: 'Minimum number of characters required message - Used on email field',
            defaultMessage: 'Email field must have at least 5 characters',
        },
        emailMaxLengthMessage: {
            id: 'authentication.email-sign-up-form.email.max-length',
            description: 'Maximum number of characters required message - Used on email field',
            defaultMessage: 'Email field must be fewer than 100 characters',
        },
        emailInvalidAddressMessage: {
            id: 'authentication.email-sign-up-form.email.invalid-address',
            description: 'Invalid email address message - Used on email field',
            defaultMessage: 'Email field is not a valid email address.',
        },
        emailRequiredMessage: {
            id: 'authentication.email-sign-up-form.email.required',
            description: 'Required value message - Used on email field',
            defaultMessage: 'Email is required',
        },
        passwordMinLengthMessage: {
            id: 'authentication.email-sign-up-form.password.min-length',
            description: 'Minimum number of characters required message - Used on password field',
            defaultMessage: 'Password field must have at least 8 characters',
        },
        passwordMaxLengthMessage: {
            id: 'authentication.email-sign-up-form.password.max-length',
            description: 'Maximum number of characters required message - Used on password field',
            defaultMessage: 'Password field must be fewer than 64 characters',
        },
        passwordRequiredMessage: {
            id: 'authentication.email-sign-up-form.password.required',
            description: 'Required value message - Used on password field',
            defaultMessage: 'Password is required',
        },
        facebookBtnMessage: {
            id: 'authentication.email-sign-up-form.btn.facebook',
            description: 'Continue with Facebook button message',
            defaultMessage: 'Continue with Facebook',
        },
        googleBtnMessage: {
            id: 'authentication.email-sign-up-form.btn.google',
            description: 'Continue with Google button message',
            defaultMessage: 'Continue with Google',
        },
        appleBtnMessage: {
            id: 'authentication.email-sign-up-form.btn.apple',
            description: 'Continue with Apple button message',
            defaultMessage: 'Continue with Apple',
        },
        orSeparatorMessage: {
            id: 'authentication.email-sign-up-form.separator',
            description: 'Form separator message',
            defaultMessage: 'or',
        },
        firstNameInputFieldMessage: {
            id: 'authentication.email-sign-up-form.input-field.first-name',
            description: 'Message for input place holder and accesibility',
            defaultMessage: 'First name',
        },
        lastNameInputFieldMessage: {
            id: 'authentication.email-sign-up-form.input-field.last-name',
            description: 'Message for input place holder and accesibility',
            defaultMessage: 'Last name',
        },
        companyInputFieldMessage: {
            id: 'authentication.email-sign-up-form.input-field.company',
            description: 'Message for input place holder and accesibility',
            defaultMessage: 'Company',
        },
        emailInputFieldMessage: {
            id: 'authentication.email-sign-up-form.input-field.email',
            description: 'Message for input place holder and accesibility',
            defaultMessage: 'Email address',
        },
        passwordPlaceHolderMessage: {
            id: 'authentication.email-sign-up-form.input-field.password.place-holder',
            description: 'Message for input place holder',
            defaultMessage: 'Create password',
        },
        passwordAriaLabelMessage: {
            id: 'authentication.email-sign-up-form.input-field.password.aria-label',
            description: 'Message for input accesibility',
            defaultMessage: 'Create password',
        },
        passwordRequiredInputFieldMessage: {
            id: 'authentication.email-sign-up-form.input-field.password.required-input',
            description: 'Required value message - Used on password input field',
            defaultMessage: 'Password must be at least 8 characters long.\u00A0',
        },
        alreadyMemberMessage: {
            id: 'authentication.email-sign-up-form.input-field.member.question',
            description: 'Already a member question message',
            defaultMessage: 'Already a member?\u00A0',
        },
        signUpBtnMessage: {
            id: 'authentication.email-sign-up-form.input-field.btn.sign-up',
            description: 'Sign up buton message',
            defaultMessage: 'Sign Up',
        },
        signInBtnMessage: {
            id: 'authentication.email-sign-up-form.input-field.btn.sign-in',
            description: 'Sign in buton message',
            defaultMessage: 'Sign In',
        },
    });
    var schema = object().shape({
        firstName: string()
            .trim()
            .max(50, intl.formatMessage(emailSignUpMessages.firstNameMaxLengthMessage))
            .required(intl.formatMessage(emailSignUpMessages.firstNameRequiredMessage)),
        lastName: string()
            .trim()
            .max(50, intl.formatMessage(emailSignUpMessages.lastNameMaxLengthMessage))
            .required(intl.formatMessage(emailSignUpMessages.lastNameRequiredMessage)),
        team: number(),
        teamName: string().when('team', {
            is: 1,
            then: string().required(intl.formatMessage(emailSignUpMessages.companyRequiredMessage)),
        }),
        email: string()
            .trim()
            .min(5, intl.formatMessage(emailSignUpMessages.emailMinLengthMessage))
            .max(100, intl.formatMessage(emailSignUpMessages.emailMaxLengthMessage))
            .email(intl.formatMessage(emailSignUpMessages.emailInvalidAddressMessage))
            .required(intl.formatMessage(emailSignUpMessages.emailRequiredMessage)),
        password: string()
            .trim()
            .min(8, intl.formatMessage(emailSignUpMessages.passwordMinLengthMessage))
            .max(64, intl.formatMessage(emailSignUpMessages.passwordMaxLengthMessage))
            .required(intl.formatMessage(emailSignUpMessages.passwordRequiredMessage)),
    });
    var _j = useForm({
        mode: 'onSubmit',
        validationSchema: schema,
    }), register = _j.register, handleSubmit = _j.handleSubmit, errors = _j.errors, setError = _j.setError, clearError = _j.clearError, getValues = _j.getValues, triggerValidation = _j.triggerValidation, setValue = _j.setValue;
    if (team && team.invitation) {
        setValue('email', team.invitation.email);
    }
    var enterKeyHandler = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var validationResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event.keyCode === 13)) return [3, 2];
                    event.preventDefault();
                    return [4, triggerValidation([
                            { name: 'firstName' },
                            { name: 'lastName' },
                            { name: 'email' },
                            { name: 'password' },
                        ])];
                case 1:
                    validationResult = _a.sent();
                    if (validationResult) {
                        onSubmit();
                    }
                    return [2];
                case 2: return [2];
            }
        });
    }); };
    useEventListener({ eventName: 'keydown', handler: enterKeyHandler });
    useEffect(function () {
        if (recaptchaResponse && recaptchaResponse !== '') {
            submitForm();
        }
    }, [recaptchaResponse]);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!isRecaptchaLoading && recaptchaRef.current) {
                executeRecaptcha();
            }
            else {
                setGeneralError('Something went wrong. Please try again.');
            }
            return [2];
        });
    }); };
    var submitForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, postData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = getValues();
                    postData = getPostData(data);
                    setIsSubmitting(true);
                    clearError();
                    setGeneralError('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, execute({ url: '/ajaxsignup', data: postData, method: 'POST' })];
                case 2:
                    response = _a.sent();
                    window.location = response.data.redirectTo;
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    handleErrorResponse(error_1);
                    setIsSubmitting(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var getPostData = function (data) {
        var postData = new URLSearchParams();
        postData.append('SignupForm[firstName]', data.firstName);
        postData.append('SignupForm[lastName]', data.lastName);
        postData.append('SignupForm[email]', data.email);
        postData.append('SignupForm[password]', data.password);
        postData.append('YII_CSRF_TOKEN', csrfToken);
        postData.append('recaptcha', recaptchaResponse ? recaptchaResponse : '');
        if (team) {
            if (team.isSignUp) {
                postData.append('SignupForm[teamName]', data.teamName);
            }
            if (team.isInvitation && team.invitation) {
                postData.append('SignupForm[teamInviteId]', team.invitation.id.toString());
            }
        }
        if (redirectTo) {
            postData.append('SignupForm[redirectTo]', redirectTo);
        }
        return postData;
    };
    var handleErrorResponse = function (error) {
        var errorMessages = defineMessages({
            generalError: {
                id: 'authentication.email-sign-up-form.error-messages.general',
                description: 'General error message  for submitted data',
                defaultMessage: 'Something went wrong. Please try again.',
            },
            generalResponseError: {
                id: 'authentication.email-sign-up-form.error-messages.response',
                description: 'General error message for response data',
                defaultMessage: 'Something went wrong. Please try again later',
            },
        });
        if (error.response.status >= 500) {
            setGeneralError(intl.formatMessage(errorMessages.generalError));
            return;
        }
        var errors = error.response.data.errors;
        if (typeof errors === 'string') {
            setGeneralError(errors);
            return;
        }
        var inputErrorFields = intersection(schema._nodes, keys(errors));
        inputErrorFields.forEach(function (field) {
            setError(field, '', errors[field][0]);
        });
        var generalErrorFields = difference(keys(errors), inputErrorFields);
        generalErrorFields.forEach(function (field) {
            setGeneralError(errors[field][0]);
        });
    };
    var onClickLogin = function (event) {
        event.preventDefault();
        if (isModal) {
            authContext.api.updateIsLogin(true);
            return;
        }
        window.location.pathname = '/login';
    };
    var handleFacebookSignUp = function (event) {
        event.preventDefault();
        facebookSignup();
    };
    var handleGoogleSignUp = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4, googleSignup()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleAppleSignUp = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4, appleSignUp()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    return (React.createElement(EmailSignUpFormStyle, null,
        React.createElement("form", null,
            showSocialLogins && (React.createElement(React.Fragment, null,
                React.createElement(FaceBookButton, { isFacebookLoading: isFacebookLoading, text: intl.formatMessage(emailSignUpMessages.facebookBtnMessage), onClick: handleFacebookSignUp }),
                React.createElement(GoogleButton, { isGoogleLoading: isGoogleLoading, text: intl.formatMessage(emailSignUpMessages.googleBtnMessage), onClick: handleGoogleSignUp }),
                React.createElement(AppleButton, { text: intl.formatMessage(emailSignUpMessages.appleBtnMessage), onClick: handleAppleSignUp }),
                React.createElement("div", { className: "form-separator" },
                    React.createElement("p", null, intl.formatMessage(emailSignUpMessages.orSeparatorMessage))))),
            React.createElement(InputError, { error: (errors.firstName && errors.firstName.message) ||
                    (errors.lastName && errors.lastName.message) ||
                    (generalError && generalError) ||
                    (recaptchaError && recaptchaError) }),
            React.createElement("div", { className: "name-inputs" },
                React.createElement("div", { className: "input" },
                    React.createElement(InputField, { placeholder: intl.formatMessage(emailSignUpMessages.firstNameInputFieldMessage), "aria-label": intl.formatMessage(emailSignUpMessages.firstNameInputFieldMessage), type: 'text', name: 'firstName', className: 'first-name', ref: register })),
                React.createElement("div", { className: "input" },
                    React.createElement(InputField, { placeholder: intl.formatMessage(emailSignUpMessages.lastNameInputFieldMessage), "aria-label": intl.formatMessage(emailSignUpMessages.lastNameInputFieldMessage), type: 'text', name: 'lastName', className: 'last-name', ref: register }))),
            team && team.isSignUp && (React.createElement(React.Fragment, null,
                React.createElement(InputError, { error: errors.teamName && errors.teamName.message }),
                React.createElement(InputField, { placeholder: intl.formatMessage(emailSignUpMessages.companyInputFieldMessage), "aria-label": intl.formatMessage(emailSignUpMessages.companyInputFieldMessage), type: 'text', name: 'teamName', className: 'signup-inputs', ref: register }),
                React.createElement(InputField, { type: 'hidden', name: 'team', value: 1, ref: register }))),
            React.createElement(InputError, { error: errors.email && errors.email.message }),
            React.createElement(InputField, { placeholder: intl.formatMessage(emailSignUpMessages.emailInputFieldMessage), "aria-label": intl.formatMessage(emailSignUpMessages.emailInputFieldMessage), type: 'email', name: 'email', className: "signup-inputs" + (team && team.invitation ? ' bold' : ''), ref: register, readOnly: team && team.invitation ? true : false }),
            React.createElement(InputError, { error: errors.password && errors.password.message }),
            React.createElement(InputField, { placeholder: intl.formatMessage(emailSignUpMessages.passwordPlaceHolderMessage), "aria-label": intl.formatMessage(emailSignUpMessages.passwordAriaLabelMessage), type: 'password', name: 'password', ref: register }),
            React.createElement("div", { className: "pass-requirement" }, intl.formatMessage(emailSignUpMessages.passwordRequiredInputFieldMessage)),
            React.createElement("div", { ref: recaptchaRef, className: "grecaptcha" }),
            React.createElement(Button, { onClick: handleSubmit(onSubmit), text: team && (team.isSignUp || team.isInvitation)
                    ? team.submitText
                    : intl.formatMessage(emailSignUpMessages.signUpBtnMessage), className: "submit-btn" + (team ? ' team' : ''), loading: isSubmitting })),
        !team && (React.createElement("div", null,
            React.createElement("div", { className: "login" },
                intl.formatMessage(emailSignUpMessages.alreadyMemberMessage),
                React.createElement("button", { className: "link", onClick: onClickLogin }, intl.formatMessage(emailSignUpMessages.signInBtnMessage))),
            React.createElement("div", { className: "form-separator" }),
            React.createElement(SignUpTerms, null)))));
};
//# sourceMappingURL=email-signup-form.js.map